// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".christmas-offer-chart[data-v-66a5b046] {\n  margin-bottom: 2.6rem;\n}\n.christmas-offer-chart svg[data-v-66a5b046] {\n  display: block;\n  margin: auto;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
